<template>
	<div>
		<Card>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">抛头/赠送率设置</span>
					</div>
				</div>
				</Col>
			</Row>

			<Row :gutter="16" style="margin:10px;">
				<Form label-position="top">
					<Col span="6">
					<FormItem label="抛头/赠送率(百分比,如10为10%)">
						<InputNumber v-model="seedFarm.additionalRate" :min="0" :max="100" :active-change="false"
							style="width:100%"></InputNumber>
					</FormItem>
					</Col>
				</Form>
			</Row>
			<Row :gutter="16" style="margin:10px;">
				<Form label-position="top">
					<Col span="4">
					<FormItem>
						<Button type="success" @click="saveSeedFarm()">保存</Button>
					</FormItem>
					</Col>
				</Form>
			</Row>
		</Card>
	</div>
</template>

<script>
import { getSeedFarmModel, saveSeedFarmAdditionalRate } from '@/api/modules/finance-management/commission';
export default {
    name: 'saveSeedFarmAdditional',
    components: {},
    data() {
        return {
            seedFarm: {
                seedFarmUuid:'',
                additionalRate:0
            }
				
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
				    this.getSeedFarm();
        },
        saveSeedFarm(){
            saveSeedFarmAdditionalRate({ seedFarmUuid:this.seedFarm.seedFarmUuid, additionalRate:this.seedFarm.additionalRate }).then(res => {
					    if (res.code === 0) {
					        this.$Message.success('抛头/赠送率设置成功！');
					    }
            });
        },
        getSeedFarm(){
            getSeedFarmModel({}).then(res => {
					    if (res.code === 0) {
					        this.seedFarm = res.data.seedFarm;
					    }
            });
        }
    }
};
</script>

<style>
</style>
